import { useRef } from "react";
import { Row, Col, Table, Button, Input, Tabs } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import Back from "../../../../assets/images/backIcon.svg";
import DefaultProductImage from "../../../../assets/images/no-image.svg";
import { KEYPAD_NO_FOCUS } from "../../../../lib/keypadNoFocus";

const { TabPane } = Tabs;

const SMProductDetailsPanel = ({
  showPaymentMethods,
  shouldShowPanel,
  stockList,
  setStockList,
  selectedProductInCart,
  currenciesList,
  pricePrecision,
  posConfig,
  handleViewStockClick,
  modifyProductList,
  cart,
  onChangeTotalQuantity,
  setIsInputFocused,
  setActiveInput,
  enterTotalQty,
  handleTotalQty,
  decreaseProductQty,
  increaseProductQty,
  showInputFields,
  qtyInputRef,
  realPrice,
  setRealPrice,
  enterRealPrice,
  handleRealPrice,
  realPriceRef,
}) => {
  return (
    <div
      style={{
        width: "81.5%",
        paddingTop: "1.5%",
        paddingBottom: "1.5%",
        display: showPaymentMethods && "none",
      }}
    >
      <div
        style={{
          background: "#fff",
          height: "41vh",
          width: "95%",
          margin: "0% 1% 1.7% 3.5%",
          border: "1px solid #fff",
          borderRadius: "7px",
          visibility: shouldShowPanel ? "visible" : "hidden",
        }}
      >
        {stockList.length > 0 ? (
          <div>
            <img
              src={Back}
              onClick={() => setStockList([])}
              id="sm-parked-bill-back"
              style={{
                height: "2vw",
                paddingBottom: "0.5em",
                cursor: "pointer",
                marginLeft: "10px",
                marginTop: "0.7em",
              }}
            />
            <Table
              style={{
                width: "100%",
                overflowY: "auto",
                borderRadius: "10px",
                padding: "0",
                height: "36vh",
                background: "#fff",
                maxHeight: "34vh",
                display: "block",
              }}
              size="small"
              locale={{ emptyText: "No data" }}
              pagination={false}
              dataSource={[...stockList]}
              className="sm-stock-table"
              columns={[
                {
                  title: "Store",
                  dataIndex: "store",
                  key: "store",
                  render: (text, record) => <div>{record?.warehouse?.name || ""}</div>,
                },
                {
                  title: "In Stock",
                  dataIndex: "stock",
                  key: "stock",
                  render: (text, record) => <div>{record?.warehouse?.storageBin?.totalQty || 0}</div>,
                  align: "right",
                },
              ]}
            />
          </div>
        ) : selectedProductInCart?.productSegment === "CB" && selectedProductInCart?.childItems?.length > 0 ? (
          <div style={{ position: "relative", padding: "0.5rem", borderRadius: "6px", backgroundColor: "#fff", height: "100%" }}>
            {/* Header Row */}
            <Row style={{ padding: "0.1rem 0.75rem", fontSize: "0.75rem", fontWeight: 600, color: "#2F3856", borderBottom: "1px solid #e8e8e8", marginBottom: "0.5rem" }}>
              <Col span={8}>Name</Col>
              <Col span={6} style={{ textAlign: "right" }}>
                Unit Price
              </Col>
              <Col span={4} style={{ textAlign: "right" }}>
                Qty
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                Total Price
              </Col>
            </Row>

            {/* Item Details */}
            <Scrollbars style={{ height: "28vh" }}>
              {selectedProductInCart.childItems.map((item) => {
                const unitPrice = parseFloat(item.sunitprice) || 0;
                const quantity = parseFloat(item.rawWeight * selectedProductInCart.weight) || 1;
                const totalPrice = unitPrice * quantity;
                const stdPrecision = item?.uomData[0]?.stdPrecision || 0;

                return (
                  <Row
                    key={item.id || item.name}
                    style={{
                      padding: "0 0.75rem",
                      width: "100%",
                      marginBottom: "0.4rem",
                      height: "auto",
                      alignItems: "center",
                    }}
                  >
                    <Col span={8}>
                      <p
                        title={item.name}
                        style={{
                          margin: 0,
                          fontSize: "0.65rem",
                          fontWeight: 500,
                          color: "#333",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                        }}
                      >
                        {item.name}
                      </p>
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.6rem",
                          color: "#2F3856",
                        }}
                      >
                        {unitPrice.toLocaleString("en-IN")}
                      </p>
                    </Col>
                    <Col span={4} style={{ textAlign: "right" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.6rem",
                          color: "#2F3856",
                        }}
                      >
                        {quantity}
                      </p>
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.6rem",
                          color: "#2F3856",
                        }}
                      >
                        {totalPrice.toLocaleString("en-IN")}
                      </p>
                    </Col>
                  </Row>
                );
              })}
            </Scrollbars>

            {/* Modify button at bottom right */}
            <Button
              style={{
                position: "absolute",
                bottom: "0.5rem",
                right: "0.5rem",
                backgroundColor: "#2F3856",
                color: "#fff",
                width: "7vw",
                height: "4.5vh",
                borderRadius: "3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                fontSize: "0.75rem",
              }}
              onClick={modifyProductList}
            >
              Modify
            </Button>
          </div>
        ) : (
          <Row gutter={[16]} style={{ paddingTop: "3vh" }}>
            <Col span={7} style={{ height: "24vh" }}>
              <img
                style={{
                  width: "100%",
                  height: "27vh",
                  objectFit: "contain",
                  borderRadius: "5px",
                  paddingTop: "1vh",
                  alignSelf: "center",
                  padding: "1vh 0 1vh 0.8vw",
                }}
                src={selectedProductInCart.imageurl || DefaultProductImage}
                alt=""
              />
            </Col>
            <Col span={17} style={{ height: "24vh", position: "relative" }}>
              <p
                style={{
                  margin: 0,
                  fontWeight: "500",
                  color: "#0F0718",
                  fontSize: "0.82rem",
                  fontFamily: "Inter",
                }}
              >
                {selectedProductInCart["name"]?.toString().substring(0, 27)}...
              </p>
              <p
                style={{
                  margin: 0,
                  fontWeight: "500",
                  color: "#0F0718",
                  fontSize: "0.82rem",
                  fontFamily: "Inter",
                }}
              >
                {selectedProductInCart["productBrandName"]}
              </p>
              <p
                style={{
                  margin: 0,
                  fontWeight: "500",
                  color: "#0F0718",
                  fontSize: "2em",
                  fontFamily: "Inter",
                }}
              >
                {currenciesList[0].symbolRightSide === "N" ? `${currenciesList[0].currSymbol}` : currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol}` : ""}{" "}
                {Number(selectedProductInCart["realPrice"]).toFixed(pricePrecision)}
              </p>
              <p
                style={{
                  margin: 0,
                  fontWeight: "500",
                  color: "#0F0718",
                  fontSize: "0.82rem",
                  fontFamily: "Inter",
                }}
              >
                Quantity : {selectedProductInCart["weight"]}
              </p>
              {stockList.length > 0 ? (
                <CloseCircleOutlined
                  onClick={() => setStockList([])}
                  style={{
                    position: "absolute",
                    top: "25vh",
                    left: "18vw",
                    cursor: "pointer",
                  }}
                />
              ) : null}
              {selectedProductInCart?.notes && selectedProductInCart?.notes.trim() !== "" && (
                <p
                  style={{
                    margin: 0,
                    fontWeight: "400",
                    color: "#0F0718",
                    fontSize: "0.95em",
                    fontFamily: "Inter",
                    marginTop: "0.5vh",
                  }}
                >
                  Notes : {selectedProductInCart?.notes}
                </p>
              )}
              {posConfig?.showViewStockInCartSection === "Y" && (
                <button
                  onClick={handleViewStockClick}
                  style={{
                    backgroundColor: "#046307C2",
                    border: "1px solid #fff",
                    borderRadius: "7px",
                    height: "5vh",
                    width: "7vw",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "row",
                      color: "#fff",
                      fontSize: "1em",
                      fontWeight: 500,
                      fontFamily: "Inter",
                    }}
                  >
                    View Stock
                  </div>
                </button>
              )}
              {stockList.map((record) => (
                <p
                  key={record.id || record.name}
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "1em",
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {record?.name || ""} stock : {record?.warehouse?.storageBin?.totalQty || 0}
                </p>
              ))}
            </Col>
          </Row>
        )}
        {stockList.length < 0 ? (
          <div style={{ padding: "1vh 1vw" }}>
            <p
              style={{
                margin: 0,
                textAlign: "left",
                color: "#0F0718",
                fontWeight: "500",
              }}
            >
              Description:
            </p>
            <p
              style={{
                margin: 0,
                textAlign: "left",
                color: "#2F3856",
                fontSize: "1em",
                fontWeight: "500",
              }}
            >
              {selectedProductInCart["description"]?.substring(0, 180)?.concat("....")}
            </p>
          </div>
        ) : null}
      </div>
      <></>
      {!showInputFields ? (
        <div>
          <Row style={{ margin: " 2% 0 0 0 " }}>
            <Input
              className="productSearch sm-payment-search totalQtyInput"
              style={{
                borderRadius: "0.5vw",
                height: "8.3vh",
                margin: "0 1% 1.7% 3.5%",
                borderRadius: "5px",
                textAlign: "right",
                fontWeight: "500",
                fontSize: "2.5em",
                borderColor: "#fff",
                color: "#2F3856",
                fontFamily: "Inter",
              }}
              ref={qtyInputRef}
              value={selectedProductInCart.weight}
              id="sm-amount-input"
              autoComplete="off"
              onChange={(e) => {
                if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 && selectedProductInCart?.restrictPosQtyEdit !== "Y") {
                  let value = e.target.value;
                  value = value.replace(/[^0-9.]/g, "");
                  const parts = value.split(".");
                  if (parts.length > 2) {
                    value = parts[0] + "." + parts.slice(1).join("");
                  }
                  onChangeTotalQuantity(value);
                }
              }}
              readOnly={cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 && selectedProductInCart?.restrictPosQtyEdit !== "Y" ? false : true}
              placeholder="Enter Quantity"
              onFocus={() => {
                setIsInputFocused(true);
              }}
              onBlur={() => {
                setIsInputFocused(false);
                setActiveInput("search");
              }}
              onPressEnter={(e) => {
                e.preventDefault();
                enterTotalQty();
              }}
            />
          </Row>
          <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                1
              </button>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                2
              </button>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                3
              </button>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS}
                className="amt-dial-btn-market"
                id="sm-amount-buttonRemove"
                onClick={() => handleTotalQty("x")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={CancelArrow}
                  alt="back space"
                  style={{
                    width: "1.4vw",
                    height: "1.4vw",
                    objectFit: "contain",
                  }}
                />
              </button>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                4
              </button>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                5
              </button>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                6
              </button>
            </Col>
            <Col span={6}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <button
                  id="sm-amount-addQuantity"
                  onClick={() => {
                    if (Object.keys(selectedProductInCart).length > 0) {
                      decreaseProductQty(selectedProductInCart);
                    }
                  }}
                  className="amt-dial-btn-market-qty"
                >
                  -
                </button>
                <button
                  id="sm-amount-addQuantity"
                  onClick={async () => {
                    if (Object.keys(selectedProductInCart).length > 0) {
                      increaseProductQty(selectedProductInCart);
                    }
                  }}
                  className="amt-dial-btn-market-qty"
                >
                  +
                </button>
              </div>
            </Col>
            <Col span={18}>
              <Row gutter={[8, 6]}>
                <Col span={8}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                    7
                  </button>
                </Col>
                <Col span={8}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                    8
                  </button>
                </Col>
                <Col span={8}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                    9
                  </button>
                </Col>
                <Col span={8}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                    0
                  </button>
                </Col>
                <Col span={8}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                    .
                  </button>
                </Col>
                <Col span={8}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                    Clear
                  </button>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <button {...KEYPAD_NO_FOCUS} id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                Enter
              </button>
            </Col>
          </Row>
        </div>
      ) : (
        <div>
          <Tabs
            defaultActiveKey="1"
            className="custom-tabs"
            onChange={(key) => {
              if (key === "2") {
                setTimeout(() => {
                  realPriceRef?.current?.focus();
                }, 10);
              } else if (key === "1") {
                setTimeout(() => {
                  qtyInputRef?.current?.focus();
                }, 10);
              }
            }}
            style={{
              marginTop: "-11%",
              marginLeft: "4%",
              width: "94%",
              height: "auto",
              zIndex: 1000,
              transition: "top 0.5s ease",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <TabPane tab="Qty" key="1" className="custom-tabpane" style={{ marginRight: "0" }}>
              <Row style={{ margin: "0 0 0 0 " }}>
                <Input
                  className="productSearch sm-payment-search totalQtyInput"
                  value={selectedProductInCart.weight}
                  style={{
                    borderRadius: "0.5vw",
                    height: "6.5vh",
                    margin: "0% 1% 1% 0%",
                    borderRadius: "5px",
                    textAlign: "right",
                    fontWeight: "500",
                    fontSize: "2.5em",
                    color: "#2F3856",
                    borderColor: "#fff",
                  }}
                  ref={qtyInputRef}
                  onChange={(e) => {
                    if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 && selectedProductInCart?.restrictPosQtyEdit !== "Y") {
                      onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
                    }
                  }}
                  onPressEnter={enterTotalQty}
                  id="sm-amount-input"
                  autoComplete="off"
                  placeholder="Enter Quantity"
                />
              </Row>
              <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                    1
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                    2
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                    3
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS}
                    className="amt-dial-btn-market"
                    id="sm-amount-buttonRemove"
                    onClick={() => handleTotalQty("x")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={CancelArrow}
                      alt="back space"
                      style={{
                        width: "1.4vw",
                        height: "1.4vw",
                        objectFit: "contain",
                      }}
                    />
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                    4
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                    5
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                    6
                  </button>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <button
                      id="sm-amount-addQuantity"
                      onClick={() => {
                        if (Object.keys(selectedProductInCart).length > 0) {
                          decreaseProductQty(selectedProductInCart);
                        }
                      }}
                      className="amt-dial-btn-market-qty"
                    >
                      -
                    </button>
                    <button
                      id="sm-amount-addQuantity"
                      onClick={async () => {
                        if (Object.keys(selectedProductInCart).length > 0) {
                          increaseProductQty(selectedProductInCart);
                        }
                      }}
                      className="amt-dial-btn-market-qty"
                    >
                      +
                    </button>
                  </div>
                </Col>
                <Col span={18}>
                  <Row gutter={[8, 6]}>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                        7
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                        8
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                        9
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                        0
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                        .
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                        Clear
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                    Enter
                  </button>
                </Col>
              </Row>
            </TabPane>
            <TabPane
              tab="Price"
              key="2"
              className="custom-tabpane"
              style={{ marginRight: "0" }}
              onClick={() => {
                setTimeout(() => {
                  realPriceRef.current.focus();
                }, 10);
              }}
            >
              <Row style={{ margin: "0 0 0 0 " }}>
                <Input
                  className="productSearch sm-payment-search totalQtyInput"
                  ref={realPriceRef}
                  value={realPrice}
                  onChange={(e) => {
                    setRealPrice(e.target.value);
                  }}
                  onPressEnter={enterRealPrice}
                  style={{
                    borderRadius: "0.5vw",
                    height: "6.5vh",
                    margin: "0% 1% 1% 0%",
                    borderRadius: "5px",
                    textAlign: "right",
                    fontWeight: "500",
                    fontSize: "2.5em",
                    color: "#2F3856",
                    borderColor: "#fff",
                  }}
                  id="sm-amount-input"
                  placeholder="Enter Price"
                />
              </Row>
              <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleRealPrice("1")}>
                    1
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleRealPrice("2")}>
                    2
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleRealPrice("3")}>
                    3
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS}
                    className="amt-dial-btn-market"
                    id="sm-amount-buttonRemove"
                    onClick={() => handleRealPrice("x")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={CancelArrow}
                      alt="back space"
                      style={{
                        width: "1.4vw",
                        height: "1.4vw",
                        objectFit: "contain",
                      }}
                    />
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleRealPrice("4")}>
                    4
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleRealPrice("5")}>
                    5
                  </button>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleRealPrice("6")}>
                    6
                  </button>
                </Col>
                <Col span={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <button {...KEYPAD_NO_FOCUS}
                      id="sm-amount-addQuantity"
                      className="amt-dial-btn-market-qty"
                      onClick={() => {
                        setRealPrice((prev) => {
                          const numeric = parseFloat(prev) || 0;
                          const newValue = Math.max(numeric - 1, 1);
                          return newValue.toString();
                        });
                      }}
                    >
                      -
                    </button>
                    <button {...KEYPAD_NO_FOCUS}
                      id="sm-amount-addQuantity"
                      className="amt-dial-btn-market-qty"
                      onClick={() => {
                        setRealPrice((prev) => {
                          const numeric = parseFloat(prev) || 0;
                          return (numeric + 1).toString();
                        });
                      }}
                    >
                      +
                    </button>
                  </div>
                </Col>
                <Col span={18}>
                  <Row gutter={[8, 6]}>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleRealPrice("7")}>
                        7
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleRealPrice("8")}>
                        8
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("9")}>
                        9
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("0")}>
                        0
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleRealPrice("00")}>
                        00
                      </button>
                    </Col>
                    <Col span={8}>
                      <button {...KEYPAD_NO_FOCUS} id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleRealPrice(".")}>
                        .
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <button {...KEYPAD_NO_FOCUS} id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterRealPrice}>
                    Enter
                  </button>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default SMProductDetailsPanel;
